import * as React from "react";
import "./index.css";
import { Box, Button } from "@mui/material";
import { TrapType, Place } from "../../../types";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { useAppSelector } from "../../../stores/store";
import { LocationMarker } from "./LocationMarker";
import MapAutoComplete from "../../AutoComplete/MapAutoComplete";

interface Props {
  initialValue?: string;
  open: boolean;
  handleClose: () => void;
  handleSave?: (data: TrapType) => void;
  handleAddressSave: (address?: string) => void;
  handleAddressSelect: (address?: Place) => void;
}

const AddressMap: React.FC<Props> = ({
  initialValue = "",
  open,
  handleClose,
  handleAddressSave,
  handleAddressSelect,
}) => {
  const refAddressInput = React.useRef(null);
  const mapCenter = useAppSelector((state) => {
    return state.user.mapCenter;
  });

  return (
    <>
      {open && (
        <div className=".modal-map">
          <Box className="modal-content-map">
            <div className="back-arrow">
              <Button
                className="btn-back-arrow"
                variant="contained"
                onClick={handleClose}
              >
                Save & Exit
              </Button>
            </div>
            <div className="modal-input-address" ref={refAddressInput}>
              <MapAutoComplete
                initialValue={initialValue}
                handleSelect={handleAddressSelect}
                handleInputChange={handleAddressSave}
              />
            </div>
            <MapContainer
              center={[
                Number.parseFloat(mapCenter?.split(",")[0] || "0"),
                Number.parseFloat(mapCenter?.split(",")[1] || "0"),
              ]}
              zoom={13}
              scrollWheelZoom={false}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <LocationMarker handleClick={handleAddressSelect} />
            </MapContainer>
          </Box>
        </div>
      )}
    </>
  );
};

export default AddressMap;
